__turbopack_context__.v({
  "textarea": "textarea-module__BRUfQa__textarea",
});
